import { createEntityAdapter } from "@reduxjs/toolkit";
import { CartItem } from "@/redux/slice/cart/types/CartItem";

export default createEntityAdapter<CartItem, string>({
  selectId: (cartItem) => cartItem.sku,
});
